( function ( $ ) {

	$( '#footer .menu .menu-item-has-children > a' ).on( 'click', function ( event ) {
		if ( $( window ).width() < 768 ) {
			event.preventDefault();
			$( this ).closest( '.menu-item' ).toggleClass( 'on' );
		}
	} );

	$( '#footer .payments-collapsible .payments-toggle' ).on( 'click', function ( event ) {
		if ( $( window ).width() < 768 ) {
			event.preventDefault();
			$( this ).closest( '.payments-collapsible' ).toggleClass( 'on' );
		}
	} );

	// $(window).resize(function(event) {
	// 	if ( $(window).width() < 768 ) {
	// 		$('#page').removeClass('sticky-footer');
	// 		$('#page').css('padding-bottom', '');
	// 	} else {
	// 		$('#page').addClass('sticky-footer');
	// 		var footerHeight = $('#footer').height();
	// 		$('#page').css('padding-bottom', footerHeight);
	// 	}
	// }).trigger('resize');

} )( jQuery );